export const TOGGLE_TASK = 'TOGGLE_TASK'

export const toggleTask = () => ({ type: TOGGLE_TASK })
